import { INTAKE_FORM_TYPE_SINGLE_TEXT } from '../../../../../utils/constants'

export function updateQuestionsOnRequiredCheckboxChange(
  // BULK SUPPRESSION: CRA -> VITE
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  questions: any[],
  questionBuilderId: string,
  isRequired: boolean,
) {
  return questions.map((question) => {
    if (question.id !== questionBuilderId) {
      return question
    }

    const updatedQuestion = {
      ...question,
      checkboxesValues: {
        ...question.checkboxesValues,
        isRequired,
      },
    }

    // Follow-up options are not required when the parent single select question is not required
    if (question.questionTypeValue === INTAKE_FORM_TYPE_SINGLE_TEXT && !isRequired) {
      // @ts-expect-error TS7006 TEMP ERROR SUPPRESSION: CRA -> REACT ROUTER
      const updatedOptions = question.options.map((option) => ({
        ...option,
        followUpRequired: false,
      }))

      return {
        ...updatedQuestion,
        options: updatedOptions,
      }
    }

    return updatedQuestion
  })
}
